import { createFileRoute } from "@tanstack/react-router";
import ExerciseLeaderboardPage from "../../../pages/Admin/ExerciseLeaderboardPage/ExerciseLeaderboardPage";
import {
  DEFAULT_LEADERBOARD_EXERCISE,
  findLeaderboardExercise,
  findLeaderboardVehicle,
} from "../../../pages/Admin/ExerciseLeaderboardPage/leaderboardExercises";

type ExerciseLeaderboardSearch = {
  exerciseTemplateVariantUuid: string;
  vehicleUuid: string;
  daysBack: number;
};

export const Route = createFileRoute("/(app)/admin/exercise-leaderboard")({
  component: RouteComponent,
  validateSearch: (
    search: Record<string, unknown>,
  ): ExerciseLeaderboardSearch => {
    const exercise =
      findLeaderboardExercise(search.exerciseTemplateVariantUuid) ??
      DEFAULT_LEADERBOARD_EXERCISE;
    const vehicle =
      findLeaderboardVehicle(exercise, search.vehicleUuid) ??
      exercise.vehicles[0];
    return {
      exerciseTemplateVariantUuid: exercise.uuid,
      vehicleUuid: vehicle.uuid,
      daysBack: Number(search.daysBack) || 30,
    };
  },
});

function RouteComponent() {
  return <ExerciseLeaderboardPage />;
}
